import { AccountingOpenPostPostingsService_openPostPostingsServiceGetQuery } from '@festina/life-general-types/life/hooks/AccountingOpenPostPostingsService_openPostPostingsServiceGetQuery'

export const useLazyFetchOpenPostPostingWithVoucher =
  AccountingOpenPostPostingsService_openPostPostingsServiceGetQuery.useLazyQuery
